import { ApiType } from "@gymflow/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { clubQueryKeys } from "./clubQueryKeys";

export function useMutationEditCancellationReason({ api }: { api: ApiType }) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (
      params: Parameters<ApiType["clubApi"]["editCancellationReason"]>[0],
    ) => api.clubApi.editCancellationReason(params),
    onSuccess: async (_, { clubId }) => {
      await queryClient.invalidateQueries({
        queryKey: clubQueryKeys.getCancellationReasonList(clubId),
      });
    },
  });
}
